import classNames from 'classnames';
import React from 'react';

function PointLeft({ color = 'text-shuttle-grey', size = 'w-4 h-4' }) {
	return (
		<svg
			viewBox="0 0 16 16"
			className={classNames(color, size)}
			fillRule="evenodd"
			fill="none"
			transform="translate(1 1)"
			strokeWidth="2"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Icons---monochrome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" className="fill-current">
				<g id="export">
					<rect id="box" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16" />
					<path
						d="M3.25574396,12.6549305 C2.9719134,12.938761 2.60253386,13.0993608 2.19872167,13.0993608 C1.79490948,13.0993608 1.42552995,12.938761 1.14169939,12.6549305 L0.444430359,11.9576614 C0.160599797,11.6738309 -4.21884749e-14,11.3044514 -4.21884749e-14,10.9006392 C-4.21884749e-14,10.496827 0.160599797,10.1274474 0.444430359,9.84361688 L6.94297772,3.34506952 C7.22680828,3.06123896 7.59618781,2.90063916 8,2.90063916 C8.40381219,2.90063916 8.77319172,3.06123896 9.05702228,3.34506952 L15.5555696,9.84361688 C15.8394002,10.1274474 16,10.496827 16,10.9006392 C16,11.3044514 15.8394002,11.6738309 15.5555696,11.9576614 L14.8583006,12.6549305 C14.57447,12.938761 14.2050905,13.0993608 13.8012783,13.0993608 C13.3974661,13.0993608 13.0280866,12.938761 12.744256,12.6549305 L8,7.91067444 L3.25574396,12.6549305 Z"
						id="point-left"
						transform="translate(8.000000, 8.000000) rotate(270.000000) translate(-8.000000, -8.000000) "
					/>
				</g>
			</g>
		</svg>
	);
}

export default PointLeft;
